import React from "react";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { ITableConfig, Table } from "../../../../../../../Shared/Table/Table";
import { Beneficiary } from "../../../../../../../../Wrap/Models/Domains/Beneficiary/Beneficiary";
import { BeneficiaryLightboxpMessage1, BeneficiaryLightboxpMessage2, BeneficiaryTypeArray, BeneficiaryTypeArraysMaps, RelationshipTypeArraysMaps, BeneficiaryProportionWarningMessage, NoBeneficiariesWarningMessage } from "../Constant/Content";
import { RadioButton } from "../../../../../../../../react-core/Html/RadioButton";
import { Objects } from "../../../../../../../../react-core/Utils/Objects";
import { BeneficiaryWidget } from "./BeneficiaryWidget";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { RelationshipMap } from "../Constant/RelationshipMap";
import { GenderOptions, GenderOptionsMap } from "../../../../NewBusinessWizard/Resource/Contents";
import { ACCEPT_DATE_FORMATS, ContentDatePicker } from "../../../../../../../Shared/Entities/Constants/DateConstants";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { DatePicker } from "../../../../../../../../react-core/Datepicker/DatePicker";
import { TextBoxEditor } from "../../../../../../../../react-core/Html/TextBoxEditor";
import { TitleMap } from "../../../../../../../Shared/Entities/Maps/TitleMap";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { PhysicalAddressType } from "../../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { BeneficiaryType } from "../../../../../../../../Wrap/Constants/Enums/Domain/BeneficiaryType";
import { ProductOverviewSippBeneficiariesAction } from "../Action/ProductOverviewSippBeneficiariesAction";
import { SubAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";
import { ValidationStatus } from "../../../../../../../../Wrap/Core/Web/Validation/ValidationStatus";
import { NumberTextBoxEditor } from "../../../../../../../../react-core/Html/NumberTextBoxEditor";
import { Gender as Gender2 } from "../../../../../../../../react-core/Enums/Gender";
import { Gender } from "../../../../../../../../Wrap/Constants/Enums/Domain/Gender";
import { BeneficiaryRelationship } from "../../../../../../../../Wrap/Constants/Enums/Domain/BeneficiaryRelationship";
import { ArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/ArrangementType";
import { BeneficiaryStatus } from "../../../../../../../../Wrap/Constants/Enums/Domain/BeneficiaryStatus";
import { Title } from "../../../../../../../../Wrap/Constants/Enums/Title";
import { CountryCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { Address as AddressModel } from "../../../../../../../../Wrap/Models/Domains/Address/Address";
import { Address } from "../../../../../../../Shared/Address/Address";
import { isNotEmpty } from "../../../../../../../../react-core/Html/Validation/RawValueRules";
import { DeleteLightbox } from "../../../../../../Common/DeleteLightbox";
import { IJsonDate } from "../../../../../../../../Wrap/System/IJsonDate";
import { PercentageTextBoxEditor } from "../../../../../../../../react-core/Html/PercentageTextBoxEditor";

interface IBeneficiaryLightboxProps extends IProcessComponentProps {
    subAccount: SubAccount;
    showBox: boolean;
    callBack: (val: boolean) => void;
    callBackOnSubmit: () => void;
    data: Array<Beneficiary>;
}

interface IBeneficiaryLightboxState {
    showWidget: boolean;
    selectedRow: Beneficiary;
    data2: Array<Beneficiary>;
    Type: BeneficiaryType;
    showProportionErrorMsg: boolean;
    showNoBeneficiariesMsg: boolean;
    showError: boolean;
    showDeletelightbox: boolean;
    hasExistingBeneficiaries: boolean;
}

export class BeneficiaryLightbox extends ProcessComponent<IBeneficiaryLightboxProps, IBeneficiaryLightboxState> {
    constructor(props: IBeneficiaryLightboxProps) {
        super(props);
        this.state = {
            selectedRow: null,
            data2: Objects.cloneObject(this.props.data || []),
            showWidget: false,
            showDeletelightbox: false,
            Type: null,
            showProportionErrorMsg: false,
            showNoBeneficiariesMsg: false,
            showError: false,
            hasExistingBeneficiaries: this.props.data.length > 0,
        };
    }

    public componentDidMount() { }

    isValid() {
        let flag = super.isValid();
        const { data2 } = this.state;
        let total = 0;

        if (data2.length > 0) {
            data2.map((item, index) => {
                total += item.Proportion;
            });

            if (total != 100) {
                return false;
            }
        }

        return flag;
    }

    hasBenficiaries() {
        const { data2 } = this.state;
        return data2.length > 0;
    }

    private formatDate = (datetime: any): string => {
        const date = new Date(datetime);

        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
        const year = date.getUTCFullYear();

        return `${day}-${month}-${year}`;
    }

    private getTableConfig(): ITableConfig[] {
        return [
            {
                title: "Type",
                key: "Type",
                render: (data, row: Beneficiary, index) => {
                    return <>{BeneficiaryTypeArraysMaps[row.Type]}</>;
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
            {
                title: "Name",
                key: "Name",
                render: (data, row: Beneficiary, index) => {
                    let title = !(row.Type == BeneficiaryType.Individual) ? "" : row?.Name?.Title == "Not specified" ? "" : row?.Name?.Title;
                    let given = isNotEmpty(row?.Name?.Given) ? row?.Name?.Given : "";
                    let family = !(row.Type == BeneficiaryType.Individual) ? "" : isNotEmpty(row?.Name?.Family) ? row?.Name?.Family : "";
                    return <>{title + " " + given + " " + family}</>;
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
            {
                title: "Relationship",
                key: "Relationship",
                render: (data, row: Beneficiary, index) => {
                    return <>{
                        row.Relationship == BeneficiaryRelationship.NotSpecified ? "" : RelationshipTypeArraysMaps[row.Relationship]
                    }</>;
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
            {
                title: "Proportion",
                key: "Proportion",
                render: (data, row: Beneficiary, index) => {
                    return <>{row.Proportion.toFixed(2)}%</>;
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
            {
                title: "Last updated",
                key: "Last updated",
                render: (data, row: Beneficiary, index) => {
                    let updateddate = row.LastModified ? this.formatDate(row.LastModified) : "";
                    return <> {updateddate}</>;
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
            {
                title: "Edit",
                key: "redioButton",
                render: (data, row: Beneficiary, index) => {
                    return (
                        <>
                            <button
                                className={"edit-circle-icon-button label-sr-only mr-2"}
                                title="Edit"
                                onClick={() =>
                                    this.setState({
                                        selectedRow: row,
                                        showWidget: true,
                                        Type: row?.Type,
                                        showProportionErrorMsg: false,
                                        showNoBeneficiariesMsg: false,
                                        showError: false,
                                    })
                                }
                            >
                                <span className="icon" aria-hidden="true"></span>
                                <span className="text">Edit</span>
                            </button>
                        </>
                    );
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
            {
                title: "Remove",
                key: "redioButton2",
                render: (data, row: Beneficiary, index) => {
                    return (
                        <>
                            <button
                                className="remove-button label-sr-only"
                                title="Delete"
                                disabled={false}
                                onClick={() => this.setState({ showDeletelightbox: true, selectedRow: row })}
                            >
                                <span className="icon" aria-hidden="true"></span>
                                <span className="text">Delete</span>
                            </button>
                        </>
                    );
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
        ];
    }
    private removeBeneficiary(row: Beneficiary) {
        const { data2 } = this.state;
        let dataCopy = Objects.cloneObject(data2);
        if (row.Id) {
            //Edit existing beneficiary
            data2.map((item, index) => {
                if (item.Id == row.Id) {
                    dataCopy.splice(index, 1);
                }
            });
        } else {
            //Edit new beneficiary
            data2.map((item, index) => {
                if (item.ResidentialAddress.TemplateId == row.ResidentialAddress.TemplateId) {
                    dataCopy.splice(index, 1);
                }
            });
        }
        this.setState({ data2: dataCopy, Type: null, selectedRow: null });
    }

    public onChange(changes, data?) {
        if (!data) {
            data = this.state.selectedRow;
        }
        let _dataCopy = JSON.parse(JSON.stringify(data || {}));
        for (let key in changes) {
            _dataCopy[key] = changes[key];
        }
        this.setState({ selectedRow: _dataCopy, showProportionErrorMsg: false, showNoBeneficiariesMsg: false });
    }

    public onDataChange(changes, data, key) {
        let _dataCopy = JSON.parse(JSON.stringify(data || {}));

        let _oldDataKeyValue = _dataCopy[key] || {};
        for (const item in changes) {
            _oldDataKeyValue[item] = JSON.parse(JSON.stringify(changes[item]));
        }
        _dataCopy[key] = _oldDataKeyValue;
        this.setState({ selectedRow: _dataCopy, showProportionErrorMsg: false, showNoBeneficiariesMsg: false });
    }

    private saveBeneficiaries() {
        const { data2, selectedRow } = this.state;
        if (super.isValid()) {
            let dataCopy = Objects.cloneObject(data2);
            if (selectedRow.Id) {
                //Edit existing beneficiary
                data2.map((item, index) => {
                    if (item.Id == selectedRow.Id) {
                        dataCopy.splice(index, 1);
                    }
                });
            } else {
                //Edit new beneficiary
                data2.map((item, index) => {
                    if (item.ResidentialAddress.TemplateId == selectedRow.ResidentialAddress.TemplateId) {
                        dataCopy.splice(index, 1);
                    }
                });
            }
            dataCopy.push(selectedRow);
            this.setState({ data2: dataCopy, Type: null, selectedRow: null });
        }
    }

    private submit() {
        if (!this.hasBenficiaries() && !this.state.hasExistingBeneficiaries) {
            this.setState({ showNoBeneficiariesMsg: true });
        }
        else if (super.isValid() && this.isValid()) {
            ProductOverviewSippBeneficiariesAction.put(
                this.props.subAccount.HierarchyId,
                this.state.data2,
                (callBack: ValidationStatus) => {
                    if (callBack.ValidationErrors.length == 0) {
                        this.setState({ selectedRow: null, Type: null });
                        this.props.callBack(false);
                        this.props.callBackOnSubmit();
                    } else {
                        this.setState({ showError: true });
                    }
                }
            );
        } else {
            this.setState({ showProportionErrorMsg: true });
        }
    }

    render() {
        const { data, showBox, callBack } = this.props;
        const { selectedRow, data2, showWidget, Type, showDeletelightbox } = this.state;
        let totalPercent = 0;
        data2.map((item, index) => {
            totalPercent += item.Proportion;
        });
        return (
            <>
                <Lightbox
                    type={LightboxType.Modal}
                    cssWrapper="is-default-lightbox"
                    show={showBox}
                    onClose={() => callBack(false)}
                    title="Edit beneficiaries"
                    isClickOutsideClose={false}
                >
                    {this.state.showError && (
                        <Alert
                            alertType={AlertType.Error}
                            message={"There is an error when submitting request, please try again."}
                        />
                    )}
                    {this.state.showProportionErrorMsg && (
                        <Alert alertType={AlertType.Error} message={BeneficiaryProportionWarningMessage} />
                    )}
                    {this.state.showNoBeneficiariesMsg && (
                        <Alert alertType={AlertType.Error} message={NoBeneficiariesWarningMessage} />
                    )}
                    <div>
                    <p>{BeneficiaryLightboxpMessage1}</p>
                    <p>{BeneficiaryLightboxpMessage2}</p>

                        {this.hasBenficiaries() && (
                            <Table
                                data={data2}
                                col={this.getTableConfig()}
                                showEmptyMsg
                                //isLoading={props.isLoading}
                                cssWrapper="mb-0"
                                SubBody={[
                                    { data: "Total", colSpan: 3 },
                                    {
                                        data: (
                                            <PercentageTextBoxEditor
                                                label=""
                                                validateOnTyping={true}
                                                onChange={(v) => {
                                                    this.onChange({ Proportion: Number(v) });
                                                }}
                                                validationRules={[
                                                    {
                                                        errorMessage: BeneficiaryProportionWarningMessage,
                                                        validator: (v) => {
                                                            if (data2.length > 0 && v != null && (!Number(v) || totalPercent != 100))
                                                                return false;
                                                            else return true;
                                                        },
                                                    },
                                                ]}
                                                required="Required"
                                                value={totalPercent}
                                                cssWrapper="control-size-100"
                                                readOnly={true}
                                            />
                                        ),
                                        colSpan: 4,
                                        tfTdCssWrapper: "cell-left",
                                    },
                                ]}
                            />
                        )}                       
                        <div>
                            {Type && (
                                <RadiosEditor
                                    cssWrapper="rg-inline mb-10"
                                    label="Beneficiary type"
                                    labelGridClasses="text-size-16 text-bold mb-10 text-text"
                                    options={BeneficiaryTypeArray}
                                    getText={(v) => {
                                        return BeneficiaryTypeArraysMaps[v];
                                    }}
                                    required="Required"
                                    selected={selectedRow?.Type}
                                    onChange={(v) => {
                                        switch (v) {
                                            case BeneficiaryType.Trustee: {
                                                selectedRow.Type = BeneficiaryType.Trustee;
                                                selectedRow.Relationship = BeneficiaryRelationship.NotSpecified;
                                                break;
                                            }
                                            case BeneficiaryType.Charity: {
                                                selectedRow.Type = BeneficiaryType.Charity;
                                                selectedRow.Relationship = BeneficiaryRelationship.NotSpecified;
                                                break;
                                            }
                                        }
                                        this.setState({ Type: v });
                                        this.onChange({ Type: v });
                                        this.onDataChange({ Given: null }, selectedRow, "Name");
                                    }}
                                />
                            )}
                            {Type == BeneficiaryType.Individual && (
                                <>
                                    <SelectEditor
                                        options={TitleMap.getArray()}
                                        cssWrapper="control-size-180"
                                        selected={TitleMap.getEnum(selectedRow?.Name?.Title)}
                                        label={"Title"}
                                        required="Required"
                                        getText={(option) => TitleMap.getString(option)}
                                        onChange={(v) => {
                                            this.onDataChange({ Title: TitleMap.getString(v) }, selectedRow, "Name");
                                        }}
                                        placeholder={"Please select"}
                                        disabled={false}
                                    />
                                    <TextBoxEditor
                                        cssWrapper="control-size-430 mr-10"
                                        value={selectedRow?.Name?.Given}
                                        label={"First name"}
                                        onChange={(v) => {
                                            this.onDataChange({ Given: v }, selectedRow, "Name");
                                        }}
                                        maxLength={20}
                                        disabled={false}
                                        required="Required"
                                        errorsWrapperCss="isNIN-error-message"
                                    />
                                    <TextBoxEditor
                                        cssWrapper="control-size-430"
                                        value={selectedRow?.Name?.Family}
                                        label={"Surname"}
                                        onChange={(v) => {
                                            this.onDataChange({ Family: v }, selectedRow, "Name");
                                        }}
                                        maxLength={20}
                                        disabled={false}
                                        required="Required"
                                        errorsWrapperCss="isNIN-error-message"
                                    />
                                </>
                            )}
                            {(Type == BeneficiaryType.Charity || Type == BeneficiaryType.Trustee) && (
                                <TextBoxEditor
                                    cssWrapper="control-size-430 mr-10"
                                    value={selectedRow?.Name?.Given}
                                    label={Type == BeneficiaryType.Charity ? "Name of organization" : "Name of Trust"}
                                    onChange={(v) => {
                                        this.onDataChange({ Given: v }, selectedRow, "Name");
                                    }}
                                    maxLength={200}
                                    disabled={false}
                                    required="Required"
                                    errorsWrapperCss="isNIN-error-message"
                                />
                            )}

                            {Type == BeneficiaryType.Individual && (
                                <DatePicker
                                    label={"Date of birth"}
                                    formGroupCssWrapper={"control-size-430"}
                                    selected={JsonDateParser.toDateNoOffset(selectedRow?.DateOfBirth)}
                                    alwaysValidateOnUpdate={true}
                                    atLeast={{
                                        value: new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
                                        errorMessage: ContentDatePicker.CannotBeInThePast,
                                    }}
                                    atMost={{
                                        value: new Date(),
                                        errorMessage: ContentDatePicker.CannotBeInTheFuture,
                                    }}
                                    showYearDropdown={true}
                                    onChange={(v) => {
                                        this.onChange({ DateOfBirth: JsonDateParser.toJsonDate(v) });
                                    }}
                                    todayButton={ContentDatePicker.Today}
                                    isClearable={true}
                                    dateFormat={ContentDatePicker.DateFormat}
                                    acceptDateFormats={ACCEPT_DATE_FORMATS}
                                    disabled={false}
                                />
                            )}
                            {Type == BeneficiaryType.Individual && (
                                <RadiosEditor
                                    cssWrapper="rg-inline mb-16"
                                    label="Gender"
                                    options={GenderOptions}
                                    getText={(v) => {
                                        return GenderOptionsMap[v];
                                    }}
                                    onChange={(v) => {
                                        this.onChange({ Gender: v });
                                    }}
                                    selected={
                                        selectedRow?.Gender == Gender.Female
                                            ? GenderOptions[1]
                                            : selectedRow?.Gender == Gender.Male
                                                ? GenderOptions[0]
                                                : null
                                    }
                                    disabled={false}
                                />
                            )}
                            {/* {Type && (
                                <Address
                                    required
                                    onChange={(v: AddressModel) => {
                                        this.onDataChange(
                                            {
                                                Line1: v.Line1 || selectedRow?.ResidentialAddress.Line1,
                                                Line2: v.Line2 || selectedRow.ResidentialAddress.Line2,
                                                Line3: v.Line3 || selectedRow.ResidentialAddress.Line3,
                                                Line4: v.Line4 || selectedRow.ResidentialAddress.Line4,
                                                Postcode: v.Postcode || selectedRow.ResidentialAddress.Postcode,
                                                CountryCode:
                                                    v.CountryCode || selectedRow.ResidentialAddress.CountryCode,
                                            },
                                            selectedRow,
                                            "ResidentialAddress"
                                        );
                                    }}
                                    data={{
                                        Line1: selectedRow?.ResidentialAddress.Line1,
                                        Line2: selectedRow.ResidentialAddress.Line2,
                                        Line3: selectedRow.ResidentialAddress.Line3,
                                        Line4: selectedRow.ResidentialAddress.Line4,
                                        Postcode: selectedRow.ResidentialAddress.Postcode,
                                        CountryCode: selectedRow.ResidentialAddress.CountryCode,
                                    }}
                                    onRef={(ref) => this.appendChild(ref)}
                                />
                            )} */}

                            {Type == BeneficiaryType.Individual && (
                                <SelectEditor
                                    options={RelationshipMap.getArray()}
                                    cssWrapper="control-size-180"
                                    selected={selectedRow.Relationship}
                                    label={"Relationship"}
                                    getText={(option) => RelationshipMap.getString(option)}
                                    onChange={(v) => {
                                        this.onChange({ Relationship: v });
                                    }}
                                    placeholder={" "}
                                    disabled={false}
                                    required="Required"
                                />
                            )}

                            {Type && (
                                <NumberTextBoxEditor
                                    label="Proportion (%)"
                                    validateOnTyping={true}
                                    onChange={(v) => {
                                        this.onChange({ Proportion: Number(v) });
                                    }}
                                    validationRules={[
                                        {
                                            errorMessage: "Invalid format, please re-enter",
                                            validator: (v) => {
                                                if (v != null && !Number(v)) return false;
                                                else return true;
                                            },
                                        },
                                    ]}
                                    maxLength={10}
                                    required="Required"
                                    value={selectedRow?.Proportion}
                                    cssWrapper="control-size-245"
                                />
                            )}
                        </div>
                    </div>
                    <div>                        
                        {/* {showWidget && (
                            <BeneficiaryWidget
                                showBox={showWidget}
                                onCloseCallBack={() => this.setState({ showWidget: false })}
                                data={selectedRow}
                                onChange={undefined}
                                onRef={function (ref: any): void {
                                    throw new Error("Function not implemented.");
                                }}
                                //onRef={(ref) => this.appendChild(ref)}
                            ></BeneficiaryWidget>
                        )} */}                    
                    </div>

                    <div>
                        {!selectedRow && (
                            <button
                                className="btn primary"
                                onClick={(val) => {
                                    let selectedRow: Beneficiary = {
                                        Type: BeneficiaryType.Individual,
                                        Proportion: 0,
                                        DateOfBirth: null,
                                        Relationship: BeneficiaryRelationship.NotSpecified,
                                        ArrangementType: ArrangementType.ExpressionOfWish,
                                        Gender: Gender.Male,
                                        Status: BeneficiaryStatus.NotSpecified,
                                        Name: { Given: "", Title: "NotSpecified", Family: "" },
                                        ResidentialAddress: {
                                            CountryCode: CountryCode.GBR,
                                            Line1: "",
                                            Line2: "",
                                            Line3: "",
                                            Line4: "",
                                            Postcode: "",
                                            TemplateId: Math.random(),
                                        },
                                    };
                                    this.setState({
                                        showWidget: true,
                                        Type: BeneficiaryType.Individual,
                                        selectedRow: selectedRow,
                                        showProportionErrorMsg: false,
                                        showError: false,
                                    });
                                }}
                            >
                                Add new
                            </button>
                        )}
                        {selectedRow && (
                            <button
                                className="btn primary"
                                onClick={(val) => {
                                    this.saveBeneficiaries();
                                }}
                            >
                                Save
                            </button>
                        )}
                    </div>

                    <div className="row mt-20">
                        <div className="col-12 col-right">
                            <button className="button mr-10" onClick={(val) => callBack(false)}>
                                Cancel
                            </button>
                            <button className="btn primary" onClick={(val) => this.submit()}>
                                Submit
                            </button>
                        </div>
                    </div>
                    <div>
                        {showDeletelightbox && (
                            <DeleteLightbox
                                onClose={() => this.setState({ showDeletelightbox: false })}
                                onDelete={() => {
                                    this.setState({ showDeletelightbox: false });
                                    this.removeBeneficiary(selectedRow);
                                }}
                                content={<p>Are you sure you want to delete this beneficiary?</p>}
                            />
                        )}
                    </div>
                </Lightbox>
            </>
        );
    }
}
